<template>
  <div class="join-us">
    <div class="null" style="width:100%;height:1px;"></div>
    <div class="p">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>品牌详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="join-main">
        <div class="left">
            <img :src="brandDetailData.logo" alt="">
        </div>
        <div class="main-right-talented">
            <p style="font-size:16px; font-weight:600;margin-bottom:20px">{{brandDetailData.alias}}</p>
            <div style="margin-bottom:20px" v-if="brandDetailData.introduction && brandDetailData.introduction !== null" v-html="brandDetailData.introduction">{{brandDetailData.introduction}}</div>
            <el-empty :image-size="200" description="暂无品牌信息" v-else></el-empty>
        </div>
    </div>
    <div class="rightfixed">
      <ul :class="searchBarFixed == true ? 'isFixed' : ''">
        <rightFixed></rightFixed>
      </ul>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Bottom from '../../components/bottom'
import rightFixed from "../productCenter/components/rightFixed";
export default {
  name: "brand",
  data() {
    return {
       brandDetailData:[],
       searchBarFixed: false,
    };
  },
  components: {
    Bottom,
    rightFixed
  },
   mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector(".rightfixed").offsetTop;
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    }
  }, 
  destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
  },
 created(){
    this.$api.homepage.brandDetail(this.$route.query.id).then(res=>{
        this.brandDetailData = res.data
    })
 }
};
</script>

<style lang="less" scoped>
.join-us {
  width: 1920px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  position: relative;
  .rightfixed {
    width: 90px;
    height: 230px;
    position: absolute;
    top: 550px;
    right: 10px;
    .isFixed {
      position: fixed;
      bottom: 150px;
      z-index: 999;
    }
  }
  .box-one {
    width: 1510px;
    height: 316px;
    background: #f6f6f6;
    margin: auto;
    background: url("../../images/four.png");
  }
  .p{
    font-size: 14px;
    margin: 24px 0px 20px 335px;
    color: #666666;
    height:19px;
    line-height: 19px;
    /deep/.el-breadcrumb__inner.is-link{
      color:#666666;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: normal;
    }
    /deep/ .el-icon-arrow-right{
      color:#666666;
    }
    /deep/ .el-breadcrumb__inner{
      cursor: pointer;
    }
  }
  .join-main {
    width: 1510px;
    background: #ffffff;
    margin: auto;
    margin-bottom: 20px;
    display: flex;
    .left {
      margin-left: 130px;
      img{
        width: 300px;
        height:200px;
        margin-top: 30px;
      }
    }
    .main-right-talented {
      width: 876px;
      min-height: 500px;
      background: #ffffff;
      margin-top: 44px;
      margin-left: 61px;
    }
  }

  .five {
    width: 805px;
    height: 49px;
    margin: auto;
    margin-top: 15px;
    font-size: 14px;
    text-align: center;
    color: #666666;
    line-height: 24px;
    span {
      font-size: 14px;
      text-align: center;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>